import {
  SLIDE_BARCODE_URL_SUCCESS,
  SLIDE_MACRO_URL_SUCCESS,
} from "../../actions/constants";
import { PWAction } from "../../utils/redux";

export type SlideMeta = {
  barcode_image_url: string;
  macro_image_url: string;
};

export type SlideMetaState = {
  [key: number]: SlideMeta;
};

const slideMetaReducer = (
  state: SlideMetaState = {},
  action: PWAction
): SlideMetaState => {
  switch (action.type) {
    case SLIDE_BARCODE_URL_SUCCESS: {
      return {
        ...state,
        [action.payload.slide_id]: {
          ...(state[action.payload.slide_id || 0] || {}),
          barcode_image_url: action.payload?.location,
        },
      };
    }
    case SLIDE_MACRO_URL_SUCCESS: {
      return {
        ...state,
        [action.payload.slide_id]: {
          ...(state[action.payload.slide_id || 0] || {}),
          macro_image_url: action.payload?.location,
        },
      };
    }
    default:
      return state;
  }
};

export default slideMetaReducer;
